import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const ChbkFinTrendTable = ({ formValues, totalValues, byYear, dim }) => {

  let { chbkPeriodId, chbkDate, distCustIds, ctrtIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds, totalCtrtIds } = totalValues;

  const gridRef = useRef();

  const rsrc = useRsrc();

  const [data, setData] = useState();

  const [fieldDefs, setFieldDefs] = useState();
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    const reqParam = {
        periodId: chbkPeriodId,
        chbkDate,
        byYear,
        agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_FIELD_DEFS_DATA_PLUGIN', reqParam).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [chbkPeriodId, chbkDate, byYear, agg]);

  useEffect(() => {
    if (!chbkPeriodId && !chbkDate) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    let ctrtIdsNot = true;
    if (totalCtrtIds.length / 2 < ctrtIds.length) {
      ctrtIds = totalCtrtIds.filter(id => !ctrtIds.includes(id));
    } else {
      ctrtIdsNot = false;
    }

    const reqParam = {
      periodId: chbkPeriodId,
      chbkDate,
      distCustIds,
      distCustIdsNot,
      ctrtIds,
      ctrtIdsNot,
      prodIds,
      prodIdsNot,
      byYear,
      agg,
      dim
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [chbkPeriodId, chbkDate, distCustIds, ctrtIds, prodIds, byYear, agg, dim]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
        gridRef.current.setDataSource(data.rows);
        gridRef.current.setTotalsRow(data.totalsRow);
    }
  }, [isGridReady, data]);

  const gridKey = useDependentKey(fieldDefs);

  return (
    <>
        <Grid
            key={gridKey}
            ref={gridRef}
            gridOptions={{
            fieldDefs,
            rowModelType: 'clientSide',
            statusBar: null
            }}
            events={{ onGridReady }}
        />
    </>

  );
};
